import request from '@/utils/request'
let brand;

function getBrand(){
  if(JSON.parse(sessionStorage.getItem("userinfo")) && JSON.parse(sessionStorage.getItem("userinfo")).brand){
    brand = JSON.parse(sessionStorage.getItem("userinfo")).brand
  }else{
    brand="gpp"
  }
}
export function importFn(data){
  getBrand();
  data.set("brand",brand);
  return request({
    url: "/v1/file/importExcel",
    method: 'post',
    data
  })
}
export function exportFn(params){
  getBrand()
  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: `/v1/file/exportExcel/${params.brand}`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function showOALink(params){
  getBrand()
  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/helpcenterV/showOALink",
    method: 'get',
    params
  })
}
export function helpSort(data){
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/helpcenter/sort",
    method: 'post',
    data
  })
}
// 根据Id查看未解决问题统计图
export function getProblemThechart(params){
  getBrand()
  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: `/v1/feedback/count/${params.id}/${params.brand}`,
    method: 'GET'
  })
}
//根据问题Id查询原因说明文本分页
export function getProblemInfoList(params){
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/feedback/text",
    method: 'GET',
    params
  })
}
//批量修改问题为热词
export function updateHotWord(data){
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/issue/updateHotWord",
    method: 'POST',
    data
  })
}
//根据id找绑定的问题
export function helpcenterInfo(params){
  getBrand()
  return request({
    url: `/v1/helpcenter/`+params+'/' + brand,
    method: 'GET',
    params
  })
}
export function getTreeUp(params){
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/classify/showtree1",
    method: 'GET',
    params
  })
}
//分类批量上下架
export function classUp(data){
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/classify/updState",
    method: 'POST',
    data
  })
}
//服务中心批量上下架
export function helpUpState(data){
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/helpcenter/updState",
    method: 'POST',
    data
  })
}
// 修改服务中心
export function editelpCenter(params) {
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/helpcenter",
    method: 'PUT',
    params
  })
}
//添加服务中心
export function addHelpCenter(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/helpcenter",
    method: 'post',
    data
  })
}
//删除服务中心
export function delHelpCenter(params){
  return request(({
    url:"/v1/helpcenter/"+params+'/' + brand,
    method:"DELETE",
  }))
}
//获取前端页面展示管理数据
export function getHelpCenterList(params) {
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/helpcenter/list",
    method: 'get',
    params
  })
}
//问题类别上下移
export function problemTypeSort(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/classify/move",
    method: 'POST',
    data
  })
}
export function problemStateUp(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/issue/updState",
    method: 'POST',
    data
  })
}
//添加分类 判断是否有问题 true 可以 flase 不可以
export function ProblemAddJudgment(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/classify/isClassify",
    method: 'POST',
    data
  })
}
// 添加 问题 判断是否有分类 true 可以 flase 不可以
export function JudgmentAddProblem(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/issue/isInsert",
    method: 'POST',
    data
  })
}
// 根据分类classify_id查询
export function classifyIdSearch(params) {
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/issue/",
    method: 'get',
    params
  })
}
//问题排序
export function problemSort(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: "/v1/issue/sort",
    method: 'post',
    data
  })
}
//根据id获取问题类型
export function getProblemTypeInfo(params) {
  getBrand()
  return request({
    url: "/v1/classify/" + params + '/' + brand,
    method: 'get',
    // application/json;charset=UTF-8
    'content-type':"application/json;charset=UTF-8"
  })
}
//修改问题类型
export function editProblemType(params) {
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: "/v1/classify",
    method: 'PUT',
    params
  })
}
//批量删除问题类型
export function delProblemType(params) {
  return request({
    url: '/v1/classify/'+params + '/' + brand,
    method: 'DELETE',
  })
}
// 新增问题分类
export function addProblemClassification(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: '/v1/classify',
    method: 'post',
    data
  })
}
//编辑问题
export function editProblemInfo(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: '/v1/issue',
    method: 'post',
    data
  })
}
// 根据id获取问题详情
export function ProblemInfo(params) {
  getBrand()
  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: '/v1/issue/getIssue/',
    method: 'get',
    params
  })
}
// 删除问题
export function delProblem(params) {
  return request({
    url: '/v1/issue/'+params + '/' + brand,
    method: 'DELETE',
  })
}
//新增问题
export function addProblem(data) {
  getBrand();
  data = {
    ...data,
    brand
  }
  return request({
    url: '/v1/issue/addServiceIssue',
    method: 'post',
    data
  })
}
// 树形
export function getTree(params) {
  getBrand()

  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: '/v1/classify/showtree',
    method: 'get',
    params
  })
}
// 问题列表
export function getProblem(params) {
  if(!params){
    params = {
      brand
    }
  }else{
    params.brand = brand;
  }
  return request({
    url: '/v1/issue/list',
    method: 'get',
    params
  })
}
//GET根据Id获取问题类型详细信息
export function getProblemInfo(params) {
  return request({
    url: '/v1/classify/'+params + '/' + brand,
    method: 'get',
  })
}
